const data = {
  counterText: 'મર્યાદિત સ્લોટ્સ ઉપલબ્ધ છે',
  loading: 'લોડિંગ',
  next: 'આગળ',
  previous: 'અગાઉના',
  smCounterText: 'મર્યાદિત સ્લોટ બાકી છે',
};

export default data;
